import * as React from 'react'
import Header from '../structure/Header/Header'
import Footer from '../structure/Footer/Footer'
import img_del from './../../Icone/moving_pipp.png'
import img_ana from './../../Icone/Dark_analytics.png'
require('./services.css')
/*
	this class is the page service.
	the user can discover our two services, the first one is to analyze and stock general condition of use of other website
	and the other one is to delete more efficiently the data of user from other website.
*/

export default class Accueil extends React.Component {

	render() {
		return (
			<>	
				<div id="other_canv">
					<div id="particles-js">
					<Header/>
					<div className="hero-wrap js-fullheight">
						<div className="overlay">
						</div>
							<div id="title-serv-header"  className="container">
								<div className="row no-gutters slider-text align-items-center justify-content-center" data-scrollax-parent="true">
										<h1 className="mb-3 bread" data-scrollax="properties: { translateY: '30%', opacity: 1.6 }">
											Nos services
										</h1>
								</div>
							</div>
						</div>
					</div>
				<section>
					<div className="container">
						<div className="row justify-content-center mb-5 pb-5">
							<div className="col-md-10 text-center heading-section ftco-animate fadeInUp ftco-animated">
								<div className="background: white">
									<span id="services" className="subheading">NOS SERVICES</span>
									<h2 id="services-txt" className="mb-10">Simplifier les CGU, dénoncer celles qui sont abusives</h2>
								</div>
							</div>
						</div>
						<div className="row justify-content-center">
							<div className="col-lg-6 ftco-animate fadeInUp ftco-animated">
								<div className="service-info">
									<div id="serv_ana">
										<img id="serv_ana" alt="service_ana" src={img_ana}></img>
									</div>
									<div id="recensement-cgu" className="media-body p-2 mt-3">
										<h3 className="heading">Recensement des Conditions Générales d'Utilisations</h3>
										<br/>
										<p>Nous récupérons, analysons et attribuons une note à toutes les CGU des sites internet afin de vous
					prévenir si elle abuse de vos données personnelles ou pas.</p>
                                        <a id="cgu_html" href="/accueil">En savoir plus</a>
									</div>
								</div>
							</div>
							<div className="col-md-10 col-lg-6 ftco-animate fadeInUp ftco-animated">
								<div className="service-info">
									<div id="serv_del">
										<img id="serv_del" alt="service_del" src={img_del}></img>
									</div>
									<div id="suppression-cgu" className="media-body p-2 mt-3">
										<h3 className="heading">Suppression de vos données personnelles</h3>
										<br/>
										<p>Nous vous proposons un service payant pour simplifier la procédure de suppression de vos données
			personnelles sur les sites que vous souhaitez.</p>
                                        <a id="supp_html" href="/suppressiondonnees">En savoir plus</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<Footer/>
				</div>
			</>
		);
	}

}